import React, { useState, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import { Button, DatePicker, Input, Select } from "antd";
import { SvgIcons } from "../../assets/svgIcons";
import { fetch_doctors_list } from "../../actions/ClinicAdminAction";
import { useDispatch, useSelector } from "react-redux";
import ResetFilterButton from "../InterbranchAdminComponents/ResetFilterButton/ResetFilterButton";
import ClearIcon from "@mui/icons-material/Clear";
import { ResetIcon } from "../../assets/Logos/Icons";
import Spinner from "react-bootstrap/Spinner";
import CustomPhoneInputV2 from "../CustomPhoneInputV2/CustomPhoneInputV2";
const { RangePicker } = DatePicker;
const { Option } = Select;

const AdminAppointmentFilters = ({
  onFilterSubmit,
  onDownloadRequest,
  onDoctorSelect,
  onAppointmentDateChange,
  onAppointmentStatusChange,
  onDateRangeChange,
  selectedRange,
  resetFilterAction,
  doctorNames,
  setAppointmentDateSearch,
  appointmentDateSearch,
  resetFilterActionDate,
  appointmentStatus,
  setAppointmentStatus,
  doctorSearch,
  selectedDoctor,
  downloaable,
  patientNumber,
  patientEmail,
  isDownloadDisabled,
  isDownloading,
  isLoading,
  handledateChange,
  setFiltersReset,
  departments,
  setDepartment,
  speciality,
}) => {
  const [formData, setFormData] = useState({
    datePreset: "TODAY",
    fromDate: "",
    toDate: "",
    filterType: "",
    patientEmail: "",
  });
  const dispatch = useDispatch();
  console.log("speciality", speciality);
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);

  const   handleOnChange = ({ name, value }) => {
    console.log("value", name, value);
    //   if (name === "filterType") {
    //     // Reset data when filterType changes
    //     handleResetFilter();
    //     setFiltersReset(true);
    //  }
    setFiltersReset(false);

    setFormData({ ...formData, [name]: value });
    console.log("data", name, value);

    if (name === "datePreset") {
      setShowDateRangePicker(value === "CUSTOM");
      // setSelectedRange(null);
    } else if (name === "department") {
      setFormData({
        ...formData,
        [name]: value, // Now we're just storing the ID
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // if(selectedRange === null ){
    //   resetFilterAction()
    // }

    // if(selectedRange !== null){
    //   console.log('selectedRange.....',selectedRange)
    //   handledateChange();
    // }
  };
  console.log("selectedRange", selectedRange);
  console.log("showDate", showDateRangePicker);

  const handleDateRangeChange = ({ name, value }) => {
    setFormData({
      ...formData,
      customDateRange: { ...formData.customDateRange, [name]: value },
    });
  };

  const handleResetFilter = () => {
    console.log("Resetting filter...");
    setFormData({
      ...formData,
      datePreset: "TODAY",
      filterType: "",
      patientEmail: "",
    });
  };

  const handleResetFilterSearch = () => {
    console.log("Resetting filter...");
    setFormData({
      ...formData,
      filterType: "",
      patientEmail: "",
      department: "",
    });
    if (selectedRange) {
      setDepartment(null);
      handledateChange(selectedRange);
    }
  };

  const handleResetFilters = () => {
    if (appointmentDateSearch !== null) {
      setAppointmentDateSearch(null);
    }
    if (appointmentStatus !== null) {
      setAppointmentStatus(null);
    }
  };

  const handleDoctorSelect = (doctorId) => {
    if (onDoctorSelect) {
      onDoctorSelect(doctorId);
    }
  };

  const handleDownload = () => {
    switch (formData.datePreset) {
      case "TODAY":
        return { name: "TODAY" };
      case "CUSTOM":
        return {
          name: "CUSTOM",
          value: {
            fromDate: formData.fromDate,
            toDate: formData.toDate,
          },
        };
      default:
        break;
    }
  };
  console.log("formData", formData);

  useEffect(() => {
    if (!selectedRange) {
      resetFilterAction();
    }
  }, [formData.filterType]);

  const handleSearch = () => {
    console.log("formData",formData)
    switch (formData.filterType) {
      case "BY_DOCTOR":
        return formData.doctorName
          ? { name: "BY_DOCTOR", value: formData.doctorName }
          : null;
      case "BY_DATE":
        return formData.appointmentDate
          ? { name: "BY_DATE", value: formData.appointmentDate }
          : null;
      case "BY_STATUS":
        return formData.AppointmentStatus
          ? { name: "BY_STATUS", value: formData.AppointmentStatus }
          : null;
      case "BY_PATIENT":
        return formData.patientName
          ? { name: "BY_PATIENT", value: formData.patientName }
          : null;
      case "BY_NUMBER":
        return formData.patientNumber
          ? { name: "BY_NUMBER", value: formData.patientNumber }
          : null;
      case "BY_EMAIL":
        return formData.patientEmail
          ? { name: "BY_EMAIL", value: formData.patientEmail }
          : null;
      case "BY_DEPARTMENT":
        return formData.department
          ? { name: "BY_DEPARTMENT", value: formData.department }
          : null;
        case "BY_SPECIALITY":
          
          return formData.speciality
          ? { name: "BY_SPECIALITY", value: formData.speciality }
          : null;
      default:
        return null;
    }
  };

  const handleSearchSubmit = () => {
    const _data = handleSearch();
    console.log("data", _data);
    if (_data && _data.value && _data.value !== "" && onFilterSubmit) {
      onFilterSubmit(_data);
      console.log("data", _data);
    } else {
      // Optionally, you can show a message to the user
      console.log("Please select a value before searching");
    }
  };

  const handleDownloadSubmit = () => {
    const _data = handleDownload();
    if (_data.name === "TODAY") {
      // Handle the "TODAY" case
      onDownloadRequest({ name: "TODAY" });
    } else {
      if (onDownloadRequest) {
        onDownloadRequest(_data.value);
      }
    }
  };

  console.log("formData.filterType", formData.filterType);

  console.log("date1", formData.datePreset);

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h5>View/Download Reports</h5>
        <div
          className={styles.itemWrap}
          style={{ maxWidth: "400px", position: "relative" }}
        >
          <div className={styles.itemContainer} >
           
            <Select
              getPopupContainer={trigger => trigger.parentNode}
              allowClear={formData.datePreset !== "TODAY"}
              placeholder="Select Date Preset"
              name="datePreset"
              onChange={(e) => {
                handleOnChange({ name: "datePreset", value: e });
              }}
              onClear={() => {
                resetFilterActionDate();
                handleResetFilter();
                setShowDateRangePicker(false);
                const newValue = "TODAY";
                handleOnChange({ name: "datePreset", value: newValue });
                setTimeout(() => {
                  handleOnChange({ name: "datePreset", value: newValue });
                }, 0);
              }}
              width={120}
              value={formData.datePreset || "TODAY"}
              options={[
                { value: "TODAY", label: "Today" },
                { value: "CUSTOM", label: "Custom" },
              ]}
            />
          </div>
          {/* {formData.datePreset === "CUSTOM" ? (
            <div style={{ position: "absolute", marginLeft: "90px" }}>
              <ClearIcon
                onClick={() => {
                  resetFilterAction();
                  setShowDateRangePicker(false);
                  handleResetFilter();
                }}
                style={{ cursor: "pointer", width: "60px", height: "11px" }}
              />
            </div>
          ) : null} */}
        </div>
        {formData.datePreset === "CUSTOM" && showDateRangePicker ? (
          <DateRangePicker
            onSearch={handleDownloadSubmit}
            onChange={handleDateRangeChange}
            onDateRangeChange={onDateRangeChange}
            formData={formData}
            resetFilterAction={resetFilterAction}
            setShowDateRangePicker={setShowDateRangePicker}
            selectedRange={selectedRange}
            resetFilterActionDate={resetFilterActionDate}
            downloaable={downloaable}
            isLoading={isLoading}
            handleResetFilter={handleResetFilter}
          />
        ) : null}
      </div>
      <div className={`${styles.section} ${styles.filterSection}`}>
        <h5>Search/Filter Results</h5>

        <div className={styles.itemWrap}>
          <div className={styles.itemContainer}>
            <Select
            getPopupContainer={trigger => trigger.parentNode}
              width={120}
              onChange={(e) => {
                handleOnChange({ name: "filterType", value: e });
              }}
              placeholder="Please select"
              value={formData.filterType != "" ? formData.filterType : null}
              options={[
                { value: "BY_DOCTOR", label: "By Doctor" },
                { value: "BY_DATE", label: "Date of Appointment" },
                { value: "BY_STATUS", label: "Appointment Status" },
                { value: "BY_PATIENT", label: "By patient name " },
                { value: "BY_NUMBER", label: "By Mobile number" },
                { value: "BY_EMAIL", label: "By Email ID" },
                { value: "BY_DEPARTMENT", label: "By Department name" },
                { value: "BY_SPECIALITY", label: "By Speciality name" },
              ]}
              className={styles.dropdownContainer}
            />
          </div>
          {
            {
              BY_DOCTOR: (
                <DoctorFilter
                  onChange={handleOnChange}
                  names={doctorNames}
                  onDoctorSelect={handleDoctorSelect}
                  resetFilterAction={resetFilterAction}
                  handleResetFilter={handleResetFilter}
                  doctorSearch={doctorSearch}
                  selectedDoctor={selectedDoctor}
                />
              ),
              BY_DATE: (
                <DatePickerFilter
                  onChange={handleOnChange}
                  onAppointmentDateChange={onAppointmentDateChange}
                  handleResetFilter={handleResetFilter}
                  setShowDateRangePicker={setShowDateRangePicker}
                  resetFilterAction={resetFilterAction}
                  appointmentDateSearch={appointmentDateSearch}
                  setAppointmentDateSearch={setAppointmentDateSearch}
                />
              ),
              BY_STATUS: (
                <StatusFilter
                  onChange={handleOnChange}
                  onStatusChange={onAppointmentStatusChange}
                  resetFilterAction={resetFilterAction}
                  handleResetFilter={handleResetFilter}
                  appointmentStatus={appointmentStatus}
                />
              ),
              BY_PATIENT: (
                <PatientFilter
                  onChange={handleOnChange}
                  resetFilterAction={resetFilterAction}
                />
              ),
              BY_NUMBER: (
                <NumberFilter
                  onChange={handleOnChange}
                  resetFilterAction={resetFilterAction}
                  patientNumber={patientNumber}
                />
              ),
              BY_EMAIL: (
                <EmailFilter
                  onChange={handleOnChange}
                  resetFilterAction={resetFilterAction}
                  patientEmail={formData?.patientEmail}
                  setFormData={setFormData}
                />
              ),
              BY_DEPARTMENT: (
                <DepartmentFilter
                  onChange={handleOnChange}
                  departments={departments}
                />
              ),
               BY_SPECIALITY: (
                <SpecialityFilter
                  onChange={handleOnChange}
                  departments={speciality}
                />
              ),
            }[formData.filterType]
          }
          <button
            onClick={handleSearchSubmit}
            className={styles.searchBtn}
            style={{
              marginLeft:
                formData.filterType === "BY_STATUS"
                  ? "40px"
                  : formData.filterType === "BY_DEPARTMENT" || formData.filterType === "BY_SPECIALITY"
                  ? "75px"
                  : "",
            }}
          >
            {" "}
            <SvgIcons.SearchIcon />
          </button>

          <button
            onClick={handleDownloadSubmit}
            className={`${styles.searchBtn} ${
              !isDownloadDisabled ? "" : styles.disabledBtn
            }`}
            // style={{marginLeft:"30px"}}
            disabled={isDownloadDisabled}
          >
            {isDownloading ? (
              <div
                className="loader"
                style={{
                  width: "100%",
                  textAlign: "center",
                  minHeight: "5px",
                  marginTop: "5px",
                }}
              >
                <Spinner
                  style={{
                    width: "20px",
                    height: "20px",
                    marginTop: "-5px",
                    color: "#fff",
                  }}
                  animation="border"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <SvgIcons.DownloadIcon />
            )}
          </button>
          {formData.filterType && (
            <div className={styles.searchBtn}>
              <ResetFilterButton
                visibility={formData.filterType}
                handleReset={() => {
                  resetFilterAction();
                  // handleResetFilter();
                  handleResetFilterSearch();
                  setFiltersReset(true);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminAppointmentFilters;

const NumberFilter = ({ onChange, resetFilterAction }) => {
  const [number, setNumber] = useState();

  const handleNumberChange = (value, formattedValue, data, event) => {
    const { dialCode, number } = data;
    setNumber(number);
    console.log("mobileNumber", { dialCode, number });
    onChange({ name: "patientNumber", value: { dialCode, number } });
  };

  return (
    <div
      className={styles.itemContainer}
      style={{ marginRight: "30px", display: "block" }}
    >
      <CustomPhoneInputV2
        placeholder="By Number"
        name="patientNumber"
        value={number}
        onChange={handleNumberChange}
        css={{
          width: "120%",
          height: "42px",
          backgroundColor: "white",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: "0",
        }}
      />
    </div>
  );
};

const DateRangePicker = ({
  onChange,
  onSearch,
  onDateRangeChange,
  resetFilterActionDate,
  handleResetFilter,
  selectedRange,
  setShowDateRangePicker,
  downloaable,
  isLoading,
  reset,
}) => {
  const handleChange = (name, value) => {
    onChange({ name, value });
  };

  const handleDateRangeChange = (dates) => {
    if (onDateRangeChange) {
      const [fromDate, toDate] = dates.map((date) =>
        date.format("DD-MMM-YYYY")
      );
      onDateRangeChange(fromDate, toDate);
    }
  };

  const handleRangePickerChange = (dates) => {
    console.log("dates.......", dates);
    if (!dates) {
      resetFilterActionDate();
      setShowDateRangePicker(false);
      handleResetFilter();
    } else {
      handleChange("fromDate", dates[0]);
      handleChange("toDate", dates[1]);
      handleDateRangeChange(dates);
    }
  };

  console.log("selectedRangeInside Datepicker", selectedRange);
  return (
    <div className={styles.itemWrap}>
      <div className={styles.itemContainer} style={{display:"flex"}}>
        <RangePicker
          onChange={handleRangePickerChange}
          format={"DD-MMM-YYYY"}
          allowClear
          getPopupContainer={trigger => trigger.parentNode}
          popupClassName={styles.customDatePickerPopup}
        />

        {/* <ResetFilterButton
        className={styles.searchBtn}
          visibility={selectedRange}
          handleReset={() => {
            resetFilterAction();
            setShowDateRangePicker(false);
            handleResetFilter();
          }}
        /> */}
        {selectedRange !== null && !isLoading ? (
          <button
            onClick={() => {
              resetFilterActionDate();
              setShowDateRangePicker(false);
              handleResetFilter();
            }}
            className={styles.searchBtn}
          >
            <ResetIcon />
          </button>
        ) : null}
      </div>
    </div>
  );
};

const DepartmentFilter = ({ onChange, departments }) => {
  const selectRef = useRef(null);

  return (
    <div className={styles.itemContainer}>
      <div ref={selectRef} style={{ position: "relative", width: "100%" }}>
        <Select
          onChange={(value, option) => {
            onChange({
              name: "department",
              value: value,
            });
          }}
          placeholder="Select Department"
          style={{ width: "140%" }}
          getPopupContainer={() => selectRef.current}
          dropdownMatchSelectWidth={false}
        >
          {departments.map((dept) => (
            <Option key={dept.id} value={dept.id}>
              {dept.name}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

const SpecialityFilter = ({ onChange, departments }) => {
  const selectRef = useRef(null);

  return (
    <div className={styles.itemContainer}>
      <div ref={selectRef} style={{ position: "relative", width: "100%" }}>
        <Select
          onChange={(value, option) => {
            onChange({
              name: "speciality",
              value: value,
            });
          }}
          placeholder="Select Speciality"
          style={{ width: "140%" }}
          getPopupContainer={() => selectRef.current}
          dropdownMatchSelectWidth={false}
        >
          {departments.map((dept) => (
            <Option key={dept.id} value={dept.id}>
              {dept.name}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

const DoctorFilter = ({
  onChange,
  names,
  resetFilterAction,
  handleResetFilter,
  doctorSearch,
}) => {
  const options = names.map((name) => ({ value: name, label: name }));
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const selectRef = useRef(null);

  const handleDoctorSelectChange = (e) => {
    setSelectedDoctor(e);
    onChange({ name: "doctorName", value: e });
  };

  const handleClearIconClick = () => {
    setSelectedDoctor(null);
    resetFilterAction();
    handleResetFilter();
  };

  return (
    <div className={styles.itemContainer}>
      <div ref={selectRef} style={{ position: "relative", width: "100%" }}>
        <Select
          onChange={handleDoctorSelectChange}
          value={selectedDoctor}
          placeholder="Choose Doctor name"
          style={{ width: "100%" }}
          options={options}
          getPopupContainer={() => selectRef.current}
          dropdownMatchSelectWidth={false}
        />
      </div>
    </div>
  );
};

const DatePickerFilter = ({
  onChange,
  onAppointmentDateChange,
  resetFilterAction,
  setShowDateRangePicker,
  handleResetFilter,
  appointmentDateSearch,
  setAppointmentDateSearch,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date, dateString) => {
    onChange({ name: "appointmentDate", value: dateString });
    onAppointmentDateChange(dateString);
    setSelectedDate(date);
  };

  const handleClearIcon = () => {
    resetFilterAction();
    setShowDateRangePicker(false);
    handleResetFilter();
    setSelectedDate(null);
    // setAppointmentDateSearch(null);
  };
  console.log("dateSearchValue", appointmentDateSearch);
  return (
    <div className={styles.itemContainer}>
      <DatePicker
        onChange={handleDateChange}
        placeholder="Select Date"
        format="DD-MMM-YYYY"
        value={selectedDate}
        getPopupContainer={trigger => trigger.parentNode}
        popupClassName={styles.customDatePickerPopup}
      />
    </div>
  );
};

const StatusFilter = ({
  onChange,
  resetFilterAction,
  handleResetFilter,
  appointmentStatus,
}) => {
  const options = [
    { label: "Completed", value: "C" },
    { label: "Doctor & Patient No-show", value: "PD" },
    { label: "Cancelled by Patient", value: "CP" },
    { label: "Upcoming", value: "P" },
    { label: "Cancelled by Doctor", value: "CD" },
    { label: "On-going", value: "On-going" },
  ];
  const [selectedValue, setSelectedValue] = useState(null);
  const selectRef = useRef(null);

  const handleClearIcon = () => {
    setSelectedValue(null);
    resetFilterAction();
    handleResetFilter();
  };

  const handleSelectChange = (e) => {
    onChange({ name: "AppointmentStatus", value: e });
    setSelectedValue(e);
  };

  console.log("selectedValue", selectedValue);

  return (
    <div className={styles.itemContainer}>
      <div ref={selectRef} style={{ position: "relative", width: "100%" }}>
        <Select
          onChange={handleSelectChange}
          value={selectedValue}
          placeholder="Select Status"
          options={options}
          style={{ width: "120%" }}
          getPopupContainer={() => selectRef.current}
          dropdownMatchSelectWidth={false}
        />
      </div>
    </div>
  );
};

const PatientFilter = ({ onChange, resetFilterAction }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && e.target.value === "") {
      // Reset the initial API here
      //resetFilterAction();
    }
  };
  return (
    <div className={styles.itemContainer}>
      <Input
        onChange={(e) => {
          onChange({ name: "patientName", value: e.target.value });
        }}
        maxLength={20}
        placeholder="By patient name"
        onKeyDown={handleKeyDown}
        onKeyPress={(e) => {
          const englishRegex = /^[a-zA-Z\s]*$/;
          if (
            !englishRegex.test(e.key) &&
            e.key !== "Backspace" &&
            e.key !== "Delete"
          ) {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          const pastedData = e.clipboardData.getData("text/plain");
          const englishRegex = /^[a-zA-Z\s]*$/;
          if (!englishRegex.test(pastedData)) {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
};

const EmailFilter = ({
  onChange,
  resetFilterAction,
  patientEmail,
  setFormData,
}) => {
  const [email, setEmail] = useState(patientEmail || "");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setEmail(patientEmail);
  }, [patientEmail]);

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    const emailRegex =
      /^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    setEmail(inputValue);
    onChange({ name: "patientEmail", value: inputValue });

    if (!emailRegex.test(inputValue) && inputValue !== "") {
      setErrorMessage("Please enter a valid email id");
    } else {
      setErrorMessage("");
    }
  };

  useEffect(() => {
    return () => {
      setEmail("");
      setFormData((prevData) => ({
        ...prevData,
        patientEmail: "",
      }));
    };
  }, []);

  return (
    <>
      <div
        className={styles.itemContainer}
        style={{ marginRight: "100px", display: "block" }}
      >
        <Input
          value={email}
          onChange={handleEmailChange}
          placeholder="By Email ID"
          style={{ width: "400px", display: "flex" }}
          maxLength={35}
          onKeyPress={(e) => {
            const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
            if (
              !englishRegex.test(e.key) &&
              e.key !== "Backspace" &&
              e.key !== "Delete"
            ) {
              e.preventDefault();
            }
          }}
          onPaste={(e) => {
            const pastedData = e.clipboardData.getData("text/plain");
            const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
            if (!englishRegex.test(pastedData)) {
              e.preventDefault();
            }
          }}
        />
      </div>
      <div style={{ position: "relative" }}>
        {errorMessage && (
          <p
            style={{
              color: "red",
              marginLeft: "-300px",
              marginTop: "25px",
              position: "absolute",
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            {errorMessage}
          </p>
        )}
      </div>
    </>
  );
};